import script from "./PaypalPayModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaypalPayModal.vue?vue&type=script&lang=ts&setup=true"

import "./PaypalPayModal.vue?vue&type=style&index=0&id=f08ee120&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f08ee120"]])

export default __exports__